import { FormControl, InputLabel } from "@mui/material";
import { useState } from "react";

import NotchedOutline from "@mui/material/OutlinedInput/NotchedOutline";
import { useTheme } from "@mui/material";

export default function OutlinedContainer(props: any) {
  const { children, label, required, width, height, addLabel = true } = props;
  const theme = useTheme();

  const [focused, setFocus] = useState(false);
  return (
    <FormControl
      className="MuiOutlinedInput-root"
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      sx={{
        width: width,
        height: height ?? 56,
        ...(!focused
          ? {
              ".MuiOutlinedInput-notchedOutline": {
                border: "1px solid rgba(0, 0, 0, 0.23)",
              },
              "&:hover": {
                ".MuiOutlinedInput-notchedOutline": {
                  borderColor: "black",
                },
              },
            }
          : {
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "blue",
                borderWidth: 2,
              },
            }),
        borderRadius: theme.shape.borderRadius + "px",
        paddingLeft: 2,
        paddingRight: 2,
        paddingTop: 1,
      }}
      variant="outlined"
    >
      {addLabel && (
        <InputLabel
          variant="outlined"
          shrink={true}
          focused={focused}
          required={required}
        >
          {<span style={{ fontWeight: "bold" }}>{label}</span>}
        </InputLabel>
      )}

      {children}
      {
        <NotchedOutline
          className="MuiOutlinedInput-notchedOutline"
          notched={true}
          label={
            label && (
              <span style={{ fontWeight: "bold" }}>
                {label + (required ? " *" : "")}
              </span>
            )
          }
        />
      }
    </FormControl>
  );
}
